import { api } from '@/services'
import { JobsBatchType } from '@/types'

export const jobs = {
    progress(id: string | number): Promise<{ data: JobsBatchType }> {
        return api.http.get(`api/v1/reports/batch-progress/${id}`)
    }
}
